import { AssertState, createShape, metadata } from "../common/mod.js";
export function transform(props) {
    return createShape({
        metadata: metadata("$.transform", transform, props),
        staticSize: props.$base.staticSize,
        subEncode(buffer, value) {
            props.$base.subEncode(buffer, props.encode(value));
        },
        subDecode(buffer) {
            return props.decode(props.$base.subDecode(buffer));
        },
        subAssert(assert) {
            props.assert?.call(this, assert);
            props.$base.subAssert(new AssertState(props.encode(assert.value), "#encode", assert));
        },
    });
}
//# sourceMappingURL=transform.js.map